import {isNullOrUndefined} from "../../../../services/Validator";

export default function ExerciserContentMetaLayout({children}) {
    // Used in MetaExerciserScreen and PreviewExerciserManager
    // to meta frame exerciser

    // BUILD
    if (isNullOrUndefined(children))
        return null
    return (
        <div className={"overflow-auto bg-backgroundLight3 w-full grow flex flex-col items-center"}>
            {children}
        </div>
    );
}